import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ChartOptions} from 'chart.js';

import Highcharts from 'highcharts';
import {HighchartsChartModule} from 'highcharts-angular';
@Component({
    selector: 'app-info-gauge',
    templateUrl: './info-gauge.component.html',
    styleUrls: ['./info-gauge.component.css']
})
export class InfoGaugeComponent implements OnInit {
    @Input() lable!: string;
    @Input() percentage?: number;
    Highcharts: typeof Highcharts = Highcharts;
    updateFlag = false;
    options: any = {};

    getChartOptions() {
        return {
            pane: {
                startAngle: -150,
                endAngle: 150,
                background: {
                    backgroundColor: 'transparent',
                    borderWidth: 0
                }
            },
            yAxis: [
                {
                    min: 0,
                    max: 100,
                    lineColor: '#0D716700',
                    tickColor: '#000000',
                    minorTickColor: '#00000000',
                    color: '#002B26',
                    offset: -5,
                    lineWidth: 10,
                    minorTickInterval: 0,
                    tickPixelInterval: 40,
                    title: {
                        text: 'المخططات',
                        style: {
                            color: '#BBB',
                            fontWeight: 'normal',
                            fontSize: '10px',
                            lineHeight: '10px'
                        },
                        y: 10
                    },
                    labels: {
                        distance: -20
                    },
                    tickLength: 5,
                    minorTickLength: 5,
                    endOnTick: false,
                    plotBands: [
                        {
                            from: 1,
                            to: 30,
                            innerRadius: '95%',
                            color: '#DF5353',
                            borderRadius: '50%'
                        },
                        {
                            from: 30,
                            to: 60,
                            color: '#DDDF0D',
                            innerRadius: '95%',
                            zIndex: 1
                        },
                        {
                            from: 60,
                            to: 119,
                            color: '#55BF3B',
                            innerRadius: '95%',
                            borderRadius: '50%'
                        }
                    ]
                }
            ],
            chart: {
                alignTicks: false,
                plotBackgroundColor: null,
                plotBackgroundImage: null,
                plotBorderWidth: 0,
                plotShadow: false
            },
            title: {
                text: null
            },
            series: [
                {
                    type: 'gauge',
                    name: 'الانجاز',
                    data: [this.percentage ?? 0],
                    dataLabels: {
                        format: '<span style="color:#000000">{y} %</span><br/>',
                        backgroundColor: {
                            linearGradient: {
                                x1: 0,
                                y1: 0,
                                x2: 0,
                                y2: 1
                            },
                            stops: [
                                [0, '#0077FF33'],
                                [1, '#FFF']
                            ]
                        }
                    },
                    dial: {
                        radius: '50%',
                        baseWidth: 5,
                        rearLength: '20%'
                    },
                    tooltip: {
                        valueSuffix: this.lable
                    }
                } as any
            ]
        };
    }

    constructor() {}

    ngOnInit() {
        this.options = this.getChartOptions();
    }

    updateChartData(percentage) {
        // debugger;
        if (!percentage) {
            if (percentage!=0){
            return;
        }
        }
        this.percentage = percentage;

        this.options = this.getChartOptions();
    }
}
